import type * as React from 'react';

// eslint-disable-next-line monorepo/forbidden-imports
import { BrazeProvider, useContentCards } from '@xing-com/braze';
// eslint-disable-next-line monorepo/forbidden-imports
import type { ContentCardContextContent, Message } from '@xing-com/braze';
import type { TrackingLibrary } from '@xing-com/braze/src/utils/tracking';
import { useContext } from '@xing-com/crate-xinglet';

import type { BrazeStoryCard, CrateBrazeContext } from '.';

const BRAZE_CONTEXT = 'braze-context';

const brazeCardHandler = (
  context: CrateBrazeContext,
  message: Message
): void => {
  if (message.type === 'contentCards') {
    context.cards = message.data as unknown as BrazeStoryCard[];
  }
};

const ContentCardProvider: React.FC<
  React.PropsWithChildren<{ section: string }>
> = ({ section, children }): React.ReactElement => {
  const { ttt } = useContext<CrateBrazeContext>(BRAZE_CONTEXT);
  return (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    <BrazeProvider transportLayer={ttt!} section={section}>
      {children}
    </BrazeProvider>
  );
};

export {
  BRAZE_CONTEXT,
  brazeCardHandler,
  ContentCardProvider,
  useContentCards,
};
export type { ContentCardContextContent, TrackingLibrary };
